export default [
	{
		path: '/auth/register',
		name: 'auth.register',
		component: () => import('@/views/Auth/Register.vue'),
		meta: { guestOnly: true }
	},
	{
		path: '/auth/admin',
		name: 'auth.admin',
		component: () => import('@/views/Auth/Admin.vue'),
		meta: { guestOnly: true }
	},
	{
		path: '/auth/login',
		name: 'auth.login',
		component: () => import('@/views/Auth/Login.vue'),
		meta: { guestOnly: true }
	},
	{
		path: '/auth/reset',
		name: 'auth.reset',
		component: () => import('@/views/Auth/Reset.vue'),
		meta: { guestOnly: true }
	},
	{
		path: '/auth/logout',
		name: 'auth.logout',
		component: () => import('@/views/Auth/Logout.vue'),
		meta: { requiresAuth: true }
	}
]
